import { render, staticRenderFns } from "./CommonOrganisationSummary.vue?vue&type=template&id=ff7d7204&scoped=true&"
import script from "./CommonOrganisationSummary.vue?vue&type=script&lang=js&"
export * from "./CommonOrganisationSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7d7204",
  null
  
)

export default component.exports